module.exports = __webpack_public_path__ + "static/media/1619_HomeSplash.9efbc313.JPG";